import { AssetHyperlinks, TAssetEvent } from '@simOn/asset/modifying/models';
import { AgentAssetHyperlink, AgentAssetReminder } from '../model';

/** Prefix of the ids the asset form gives new entries; `toCreateAsset()` turns them into `null` for the API. */
export const TEMP_ID_PREFIX = 'temp-';

const tempId = (): string => `${TEMP_ID_PREFIX}${crypto.randomUUID()}`;

/** Reminders of a card as the asset form state holds them; stored entries keep their id, new ones get a temp id. */
export const toAssetFormEvents = (events: AgentAssetReminder[]): TAssetEvent[] =>
  events.map(({ id, dateTime, content, recurringEventType }) => ({
    id: id ?? tempId(),
    dateTime,
    content,
    recurringEventType: recurringEventType ?? undefined
  }));

/** Links of a card as the asset form state holds them; same id rule as {@link toAssetFormEvents}. */
export const toAssetFormHyperlinks = (links: AgentAssetHyperlink[]): AssetHyperlinks[] =>
  links.map(({ id, hyperlink }) => ({ id: id ?? tempId(), hyperlink }));
